import { DecreaseIcon, IncreaseIcon } from "assets/icons";
import cn from "classnames";
import { t } from "i18next";
import Skeleton from "react-loading-skeleton";
import { Icon } from "ui/Icon";

import { StatProps } from "./Stat.types";

import styles from "./Stat.module.scss";

const Stat = ({
  size = "sm",
  title,
  amount,
  percentage,
  isLoadingAmount,
  className
}: StatProps) => {
  const increase = percentage ? percentage >= 0 : null;
  const formattedPercentage = percentage ? Math.floor(percentage) : null;

  return (
    <div className={cn(styles.stat, className)}>
      <p className={cn(styles.stat__title, styles[`stat__title-${size}`])}>
        {t(title)}
      </p>

      {isLoadingAmount ? (
        <Skeleton
          className={cn(
            styles.stat__skeleton,
            styles[`stat__skeleton-${size}`]
          )}
          count={1}
        />
      ) : (
        <div className={styles.stat__amount}>
          <p
            className={cn(
              styles["stat__amount--number"],
              styles[`stat__amount--number-${size}`]
            )}
          >
            {amount ?? 0}
          </p>
          {formattedPercentage && (
            <div className={styles["stat__amount--percentage"]}>
              {increase ? (
                <Icon as={IncreaseIcon} color="#16C350" />
              ) : (
                <Icon as={DecreaseIcon} color="#FF0033" />
              )}
              <p
                className={cn(styles["stat__amount--percentage-count"], {
                  [styles["stat__amount--percentage-count-decrease"]]: !increase
                })}
              >
                {isFinite(formattedPercentage)
                  ? `${formattedPercentage}`
                  : "100"}{" "}
                %
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Stat;
